import { AddressSuggestion } from './models';

export const getAddressSuggestions = async (query: string): Promise<Array<AddressSuggestion>> => {
    const searchParams = new URLSearchParams({ q: query });
    const response = await fetch(
        `/api/integrations/addresses/autocomplete?${searchParams.toString()}`,
    );

    if (!response.ok) {
        throw new Error(`Address lookup failed: ${response.status} ${response.statusText}`);
    }

    const body: unknown = await response.json();

    return Array.isArray(body) ? (body as Array<AddressSuggestion>) : [];
};
